import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {Password} from 'primereact/password';
import {Link} from "react-router-dom";
import {Button} from 'primereact/button';
import {Panel} from "primereact/panel";
import {InputSwitch} from "primereact/inputswitch";
import axios from "axios";
import Cookies from "js-cookie";
import ThemelinksComponent from "../components/ThemelinksComponent";
import LanglinksComponent from "../components/LanglinksComponent";

const RegistrationPage = (props) => {

  const {t, i18n} = props;
  const [formData, setFormData] = useState({
    paycenter: {
      create_account: false,
      system_name: ''
    }
  });
  const [terms, setTerms] = useState(false);
  const [privacy, setProvacy] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingProgress, setLoadingProgress] = useState(0);

  const validate = (data) => {
    let errors = {};
    if (!data.system_name) {
      errors.system_name = t('required_field');
    }
    if (!data.plain_password) {
      errors.plain_password = t('required_field');
      errors.repeat_password = t('required_field');
    }
    if (!data.email) {
      errors.email = t('required_field');
    }
    if (data.repeat_password && data.plain_password != data.repeat_password) {
      errors.plain_password = t('passwords_not_match');
      errors.repeat_password = t('passwords_not_match');
    }
    if (!terms) {
      errors.terms = t('required_to_accept');
    }
    if (!privacy) {
      errors.privacy = t('required_to_accept');
    }
    return errors;
  };

  const onSubmit = (data, form) => {
    const shouldCheckPaycenterRegistration = Boolean(formData?.paycenter?.create_account);
    setLoadingProgress(0);
    setLoading(true)
    axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "register",
      formData,
      {
        params: {},
        headers: {
          "Preferred-locale": Cookies.get("language")
        }
      })
      .then(response => {
        setLoadingProgress(100);
        window.App.toastShow('success', t('registration_success'))
        setTimeout(() => {
          const paycenterRegistration = response?.data?.data?.paycenter_registration;
          const paycenterStatus = paycenterRegistration?.status;
          const successfulPaycenterStatuses = ['success', 'connected', 'completed'];
          const isPaycenterRegistrationSuccessful = successfulPaycenterStatuses.includes(paycenterStatus);
          const isPaycenterRegistrationError = Boolean(paycenterRegistration?.error_code) || paycenterStatus?.includes('error');

          if (shouldCheckPaycenterRegistration && paycenterRegistration) {
            if (isPaycenterRegistrationSuccessful && !isPaycenterRegistrationError) {
              window.App.toastShow('success', t('success'), t('register_paycenter_success'))
            } else {
              window.App.toastShow('warn', t('warning'), t('register_paycenter_failed'))
            }
          }
        }, 500)
        setTimeout(() => {
          window.location.replace('/#/');
          window.App.forceUpdate()
        }, 150)
      })
      .catch(error => {
        setLoadingProgress(100);
        setTimeout(() => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        }, 150)
      })

  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  useEffect(() => {
    document.getElementById('body').classList.add('outside')
    document.title = t('registration') + ' - ' + process.env.REACT_APP_TITLE;
  }, []);

  useEffect(() => {
    if (!loading) {
      setLoadingProgress(0);
      return;
    }
    setLoadingProgress(0);
    const intervalId = setInterval(() => {
      setLoadingProgress((prev) => (prev < 100 ? prev + 1 : 100));
    }, 150);
    return () => {
      clearInterval(intervalId);
    };
  }, [loading]);

  const loadingSteps = [
    t('registration_loading_step_start'),
    t('registration_loading_step_database'),
    t('registration_loading_step_seed'),
    t('registration_loading_step_finalize')
  ];

  const currentStepIndex = Math.min(Math.floor(loadingProgress / 25) + 1, loadingSteps.length - 1);

  return (
    <div className="RegistrationPage p-component">
      {Cookies.get('theme') === 'dark' ? (
        <img src={require(".." + process.env.REACT_APP_LOGO_FILE_DARK)} className="p-d-block p-my-5 p-mx-auto"/>
      ) : (
        <img src={require(".." + process.env.REACT_APP_LOGO_FILE)} className="p-d-block p-my-5 p-mx-auto"/>
      )}
      <Panel>
        <div className={"p-grid p-mb-4"}>
          <div className={"p-col-6 p-lg-6 p-xl-6 p-col-align-center"}>
            <h3 className={"p-m-0"}>
              {!loading && <><i className={"pi pi-user"}></i> {t('registration')}</> }
            </h3>
          </div>
          <div className={"p-col-6 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
            <ThemelinksComponent/>&nbsp;&nbsp;|&nbsp;&nbsp;<LanglinksComponent/>
          </div>
        </div>
        {loading ? (
          <div className="register-loading">
            <div className="register-loading__orbit">
              <div className="register-loading__ring register-loading__ring--outer"/>
              <div className="register-loading__ring register-loading__ring--inner"/>
              <div className="register-loading__dot register-loading__dot--one"/>
              <div className="register-loading__dot register-loading__dot--two"/>
              <div className="register-loading__core">
                <span>{loadingProgress}%</span>
              </div>
            </div>
            <h4 className="register-loading__title">{t('registration_loading_title')}</h4>
            <div className="register-loading__steps">
              {loadingSteps.map((step, index) => {
                const isCompleted = index === 0 || loadingProgress >= index * 25;
                const isActive = !isCompleted && index === currentStepIndex;
                return (
                  <div
                    className={"register-loading__step" + (isCompleted ? ' is-completed' : '') + (isActive ? ' is-active' : '')}
                    key={step}>
                    <i
                      className={"pi " + (isCompleted ? 'pi-check-circle' : (isActive ? 'pi-spin pi-spinner' : 'pi-spinner'))}/>
                    <span>{step}</span>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <Form onSubmit={onSubmit}
                className="p-d-block p-mx-auto"
                initialValues={formData}
                validate={validate} render={({handleSubmit}) => {
            return (
              <form onSubmit={handleSubmit}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6"}>
                    <Field name="system_name" tabindex="1" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <label htmlFor="system_name"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>{t('instance_name')}</label>
                        <span className="p-d-block">
                      <InputText id="system_name" {...input}
                                 autoFocus
                                 disabled={loading}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     system_name: e.target.value
                                   })
                                 }}
                                 value={formData.system_name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                      <small className={"p-field-helper"}>
                          {t('instance_name_helper')}
                      </small>
                    </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                  <div className={"p-col-12 p-lg-6"}>
                    <Field name="name" tabindex="2" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <label htmlFor="name"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>{t('your_name')}</label>
                        <span className="p-d-block">
                      <InputText id="name" {...input}
                                 disabled={loading}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                </div>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6"}>
                    <Field name="email" tabindex="3" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <label htmlFor="email"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>{t('email')}</label>
                        <span className="p-d-block">
                      <InputText id="email" {...input}
                                 disabled={loading}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     email: e.target.value
                                   })
                                 }}
                                 value={formData.email}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                </div>
                <div className={"p-grid"}>
                  {/*<div className={"p-col-12 p-lg-6"}>*/}
                  {/*  <Field name="phone" tabindex="4" render={({input, meta}) => (*/}
                  {/*    <div className="p-field p-fluid">*/}
                  {/*      <label htmlFor="phone"*/}
                  {/*             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('phone')}</label>*/}
                  {/*      <span className="p-d-block">*/}
                  {/*        <InputText id="phone" {...input}*/}
                  {/*                   onChange={(e) => {*/}
                  {/*                     setFormData({*/}
                  {/*                       ...formData,*/}
                  {/*                       phone: e.target.value*/}
                  {/*                     })*/}
                  {/*                   }}*/}
                  {/*                   value={formData.phone}*/}
                  {/*                   className={classNames({'p-invalid': isFormFieldValid(meta)})}/>*/}
                  {/*      </span>*/}
                  {/*      {getFormErrorMessage(meta)}*/}
                  {/*    </div>*/}
                  {/*  )}/>*/}
                  {/*</div>*/}
                  <div className={"p-col-12 p-lg-6"}>
                    <Field name="plain_password" tabindex="5" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <label htmlFor="plain_password"
                               className={"" + classNames({'p-error': isFormFieldValid(meta)})}>{t('password')}</label>
                        <span className="p-d-block">
                    <Password id="plain_password" {...input}
                              toggleMask
                              feedback={false}
                              disabled={loading}
                              value={formData.plain_password}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  plain_password: e.target.value
                                })
                              }}
                              className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                  <div className={"p-col-12 p-lg-6"}>
                    <Field name="repeat_password" tabindex="6" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <label htmlFor="repeat_password"
                               className={"" + classNames({'p-error': isFormFieldValid(meta)})}>{t('password_check')}</label>
                        <span className="p-d-block">
                    <Password id="repeat_password"
                              {...input}
                              toggleMask
                              feedback={false}
                              disabled={loading}
                              value={formData.repeat_password}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  repeat_password: e.target.value
                                })
                              }}
                              className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                </div>
                {/*<div className={"p-grid p-mt-1 p-mb-3"} style={{backgroundColor: '#f5f5f5'}}>*/}
                {/*  <div className={"p-col-12 p-lg-6 p-col-align-center p-py-0"}>*/}
                {/*    <Field name="paycenter.create_account" tabindex="9" render={({input, meta}) => (*/}
                {/*      <>*/}
                {/*        <div className={"p-grid"}>*/}
                {/*          <div className={"p-col p-col-align-center"} style={{maxWidth: '60px'}}>*/}
                {/*            <div className="p-field p-fluid p-mb-0">*/}
                {/*              <InputSwitch*/}
                {/*                className={"p-mt-3"}*/}
                {/*                disabled={loading}*/}
                {/*                checked={formData?.paycenter?.create_account}*/}
                {/*                value={formData?.paycenter?.create_account}*/}
                {/*                onChange={e => {*/}
                {/*                  setFormData({*/}
                {/*                    ...formData,*/}
                {/*                    paycenter: {...formData.paycenter, create_account: e.value}*/}
                {/*                  })*/}
                {/*                }*/}
                {/*                }/>*/}
                {/*            </div>*/}
                {/*          </div>*/}
                {/*          <div className={"p-col p-col-align-center"}>*/}
                {/*            <small className={"p-d-block p-pt-2"}>*/}
                {/*              {t('register_create_paycenter_prefix')}*/}
                {/*              <a href={process.env.REACT_APP_PAYCENTER_REGISTER_URL}*/}
                {/*                 target={"_blank"}*/}
                {/*                 rel={"noopener noreferrer"}*/}
                {/*                 style={{textDecoration: 'none', color: '#2196f3', fontWeight: '700'}}>*/}
                {/*                {t('paycenter_account')}*/}
                {/*              </a>*/}
                {/*              {t('register_create_paycenter_suffix')}*/}
                {/*            </small>*/}
                {/*            {getFormErrorMessage(meta)}*/}
                {/*          </div>*/}
                {/*        </div>*/}
                {/*      </>*/}
                {/*    )}/>*/}
                {/*  </div>*/}
                {/*  <div className={"p-col-12 p-lg-6 p-col-align-center"}>*/}
                {/*    {formData?.paycenter?.create_account &&*/}
                {/*      <Field name="paycenter.system_name" tabindex="10" render={({input, meta}) => (*/}
                {/*        <div className="p-field p-fluid p-mb-0">*/}
                {/*      <span className="p-d-block">*/}
                {/*        <InputText id="paycenter_system_name" {...input}*/}
                {/*                   disabled={loading}*/}
                {/*                   placeholder={t('register_paycenter_system_name')}*/}
                {/*                   onChange={(e) => {*/}
                {/*                     setFormData({*/}
                {/*                       ...formData,*/}
                {/*                       paycenter: {...formData.paycenter, system_name: e.target.value}*/}
                {/*                     })*/}
                {/*                   }}*/}
                {/*                   value={formData?.paycenter?.system_name}*/}
                {/*                   className={classNames({'p-invalid': isFormFieldValid(meta)})}/>*/}
                {/*      </span>*/}
                {/*          {getFormErrorMessage(meta)}*/}
                {/*        </div>*/}
                {/*      )}/>*/}
                {/*    }*/}
                {/*  </div>*/}
                {/*</div>*/}
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-col-align-center"}>
                    <Field name="terms" tabindex="7" render={({input, meta}) => (
                      <>
                        <div className={"p-grid"}>
                          <div className={"p-col"} style={{maxWidth: '60px'}}>
                            <div className="p-field p-fluid p-mb-0">
                              <InputSwitch
                                className={"p-mt-1"}
                                disabled={loading}
                                checked={terms}
                                value={terms}
                                onChange={e => setTerms(e.target.value)}/>
                            </div>
                          </div>
                          <div className={"p-col-10 p-col-align-center"}>
                            <small className={"p-d-block"}>
                              {t('accept_terms_and_conditions_prefix')}
                              <a href={process.env.REACT_APP_REGISTRATION_EULA}
                                 target={"_blank"}
                                 rel={"noopener noreferrer"}
                                 style={{textDecoration: 'none', color: '#2196f3', fontWeight: '700'}}>
                                {t('terms_and_conditions_name')}
                              </a>
                              {t('accept_terms_and_conditions_suffix')}
                            </small>
                            {getFormErrorMessage(meta)}
                          </div>
                        </div>
                      </>
                    )}/>
                  </div>
                </div>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-col-align-center"}>
                    <Field name="privacy" tabindex="8" render={({input, meta}) => (
                      <>
                        <div className={"p-grid"}>
                          <div className={"p-col"} style={{maxWidth: '60px'}}>
                            <div className="p-field p-fluid p-mb-0">
                              <InputSwitch
                                className={"p-mt-1"}
                                disabled={loading}
                                checked={privacy}
                                value={privacy}
                                onChange={e => setProvacy(e.target.value)}/>
                            </div>
                          </div>
                          <div className={"p-col-10 p-col-align-center"}>
                            <small className={"p-d-block"}>
                              {t('accept_privacy_data_prefix')}
                              <a href={process.env.REACT_APP_REGISTRATION_PP}
                                 target={"_blank"}
                                 rel={"noopener noreferrer"}
                                 style={{textDecoration: 'none', color: '#2196f3', fontWeight: '700'}}>
                                {t('privacy_policy_name')}
                              </a>
                              {t('accept_privacy_data_suffix')}
                            </small>
                            {getFormErrorMessage(meta)}
                          </div>
                        </div>
                      </>
                    )}/>
                  </div>
                </div>
                <div className={"p-grid p-mt-2"}>
                  <div className={"p-col-12 p-lg-6 p-xl-6"}>
                    <Link to={"/"} className={"p-d-block"} tabindex="-1" style={{textDecoration: 'none', color: '#2196f3', fontWeight: '700'}}>{t('login_instead')}</Link>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"} tabindex="11">
                    <Button type="submit"
                            label={t('registration')}
                            className="p-button-success"
                            icon={"pi pi-check"}
                            loading={loading} disabled={loading}/>
                  </div>
                </div>
              </form>
            )
          }}/>
        )}
      </Panel>
    </div>
  )
}
export default withTranslation('common')(RegistrationPage);
